import {
  Database,
  ShieldCheck,
  Lock,
  Cookie,
  Users,
  UserCheck,
  RefreshCw,
  Clock,
} from "lucide-react";

const privacyData = [
  {
    icon: Database,

    title: "Information We Collect",

    description:
      "To provide high-quality digital services, we may collect certain personal and business information that you voluntarily share while interacting with our website.",

    points: [
      "Personal Information (Full Name, Email Address, Phone Number)",
      "Business Information (Company Name and Business Enquiries)",
      "Career Information (Job Applications and Uploaded Documents)",
      "Website Usage Information (Browsing Activity and Analytics)",
      "Any Additional Information You Voluntarily Provide",
    ],
  },

  {
    icon: ShieldCheck,

    title: "How We Use Your Information",

    description:
      "The information we collect is used solely for legitimate business purposes to enhance our services and improve your overall experience.",

    points: [
      "Respond to enquiries and provide customer support",
      "Deliver requested software services and project updates",
      "Schedule consultations and communicate with you",
      "Improve website performance, functionality, and user experience",
      "Conduct internal analytics to enhance our services and business operations",
    ],
  },

  {
    icon: Cookie,

    title: "Cookies & Tracking Technologies",

    description:
      "Our website uses cookies and similar technologies to improve functionality, personalize user experience, and better understand visitor behavior.",

    points: [
      "Remember your preferences and website settings",
      "Analyze website traffic and visitor interactions",
      "Measure and improve website performance",
      "Enhance security and prevent fraudulent activities",
      "Support analytics and optimize user experience",
    ],
  },

  {
    icon: Lock,

    title: "Data Protection & Security",

    description:
      "Protecting your information is one of our highest priorities. We implement industry-standard security measures to safeguard the personal and business data you share with us.",

    points: [
      "Secure data storage using industry-standard security practices",
      "Encrypted communication to protect data during transmission",
      "Restricted access to authorized personnel only",
      "Regular security monitoring and vulnerability assessments",
      "Appropriate measures to maintain data confidentiality and integrity",
    ],
  },

  {
    icon: Users,

    title: "Information Sharing",

    description:
      "We respect your privacy and never sell your personal information. Information may only be shared when necessary for business operations or legal obligations.",

    points: [
      "We do not sell your personal information",
      "Shared with trusted service providers",
      "Required for service delivery",
      "Disclosed to comply with legal obligations",
      "Protected through confidentiality measures",
    ],
  },
  {
    icon: UserCheck,

    title: "Your Privacy Rights",

    description:
      "You remain in control of your personal information and may exercise various rights regarding the data we maintain.",

    points: [
      "Request access to your personal data",
      "Update or correct your information",
      "Request deletion of your personal data",
      "Withdraw consent where applicable",
      "Contact us with privacy-related concerns",
    ],
  },

  {
    icon: Clock,

    title: "Data Retention",

    description:
      "Personal information is retained only for the period necessary to fulfill business purposes, comply with legal obligations, and support service delivery.",

    points: [
      "Retained for legitimate business purposes",
      "Stored to comply with legal obligations",
      "Maintained for customer support needs",
      "Kept only as long as necessary",
      "Securely deleted when no longer required",
    ],
  },

  {
    icon: RefreshCw,

    title: "Policy Updates",

    description:
      "Our Privacy Policy may be updated periodically to reflect changes in business operations, technologies, industry standards, or applicable laws.",

    points: [
      "Policy reviewed periodically",
      "Updated to reflect legal changes",
      "Revised for technology improvements",
      "Aligned with business practices",
      "Changes published on this page",
    ],
  },
];

export default privacyData;
